/**
 * This variable represents the number of offers that will be requested in the query.
 *
 * The number should be evenly divisible by 4
 */
export const OFFERS_PER_SEARCH = 12
